<div class="modal-content">
  <button type="button" class="btn-close" aria-label="Close" (click)="onCloseClick()"></button>
  <div class="modal-body">
    <img src="{{ options.imageUrl }}" alt="{{ options.altText }}" />
  <div>
</div>
